import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Package, Users, Building2, ShieldCheck, ArrowRight } from "lucide-react";

export default function BusinessDashboard() {
  const { user } = useAuth();
  const [dash, setDash] = useState(null);

  useEffect(() => { api.get("/business/dashboard").then((r) => setDash(r.data)).catch(() => {}); }, []);

  const metrics = dash ? [
    { label: "Passeports actifs", value: dash.metrics.passports_active, icon: Package },
    { label: "Produits suivis", value: dash.metrics.products_tracked, icon: Package },
    { label: "Catalogue", value: dash.metrics.catalog_entries, icon: Building2 },
    { label: "Leads", value: dash.metrics.leads, icon: Users },
  ] : [];

  return (
    <div className="space-y-6" data-testid="business-dashboard">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">{user.business.company_name}</h1>
        <p className="text-muted-foreground text-sm mt-1">Console {user.business.account_type} · Plan {user.business.plan}</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics.map((m, i) => (
          <div key={i} data-testid={`biz-metric-${i}`} className="omy-glass rounded-2xl p-5">
            <m.icon size={18} className="text-indigo-300 mb-3" />
            <div className="text-2xl font-display font-semibold">{m.value}</div>
            <div className="text-xs text-muted-foreground">{m.label}</div>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <Link to="/business-app/catalogue" data-testid="biz-quick-catalogue"
          className="omy-glass rounded-2xl p-6 hover:border-indigo-400/40 hover:-translate-y-1 transition-all group">
          <Package size={20} className="text-indigo-300 mb-3" />
          <h2 className="font-display font-medium flex items-center gap-2">Catalogue produits <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></h2>
          <p className="text-sm text-muted-foreground mt-1">Publie tes passeports numériques (GTIN, modèle, garantie officielle).</p>
        </Link>
        <Link to="/business-app/revendications" data-testid="biz-quick-claims"
          className="omy-glass rounded-2xl p-6 hover:border-indigo-400/40 hover:-translate-y-1 transition-all group">
          <ShieldCheck size={20} className="text-indigo-300 mb-3" />
          <h2 className="font-display font-medium flex items-center gap-2">Revendiquer des passeports <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></h2>
          <p className="text-sm text-muted-foreground mt-1">Pousse garantie et notice officielles aux biens de tes clients.</p>
        </Link>
      </div>
    </div>
  );
}
